import intro from "./intro"
import authentication from "./authentication"
import productsAndFields from "./products-and-fields"
import purchseDraftAndCompletion from "./purchase-draft-and-completion"
import invoicing from "./invoicing"
import webhooks from "./webhooks"

// import authentication from './authentication.json'
// import products from './products.json'
// import completion from './completion.json'
// import properties from './properties.json'
// import not_found from './not_found.json'
// import intro from './intro.json'
// import invoicing from './invoicing.json'

// import  from './products'

const pages = {
  introduction: intro,
  authentication: authentication,
  products: productsAndFields,
  purchase: purchseDraftAndCompletion,
  invoicing: invoicing,
  webhooks: webhooks
}

const getPage = (page) => {
  if(!page) {
    return intro
  }
  if(pages[page]) {
    return pages[page]
  }
  return intro
}

export { getPage }